// extracted by mini-css-extract-plugin
module.exports = {"overlay-mask":"bet-container_overlay-mask__2aUSg","bet-container":"bet-container_bet-container__2iv_k"};